"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Gradient = exports.OpacityStop = exports.GradientStop = exports.GradientInterpolationType = exports.GradientType = void 0;

var _colorCore = require("@capture/color-core");

const GradientType = Object.freeze({
  LINEAR: 'linear',
  RADIAL: 'radial'
});
exports.GradientType = GradientType;
const GradientInterpolationType = Object.freeze({
  LINEAR: 'linear',
  EUCLIDEAN: 'euclidean',
  SPLINE: 'spline'
});
exports.GradientInterpolationType = GradientInterpolationType;

class GradientStop {
  constructor(color, offset = 0.0, midPoint = 0.5) {
    this.color = new _colorCore.ColorSwatch(new _colorCore.ColorSwatchRep());
    this.midpoint = 0.5;
    this.offset = 0.0;
    this.color = color;
    this.offset = offset;
    this.midpoint = midPoint;
  }

  static get GradientVersion() {
    return '1.0';
  }

}

exports.GradientStop = GradientStop;

class OpacityStop {
  constructor(opacity, offset = 0.0, midPoint = 0.5) {
    this.opacity = 1.0;
    this.midpoint = 0.5;
    this.offset = 0.0;
    this.opacity = opacity;
    this.offset = offset;
    this.midpoint = midPoint;
  }

}

exports.OpacityStop = OpacityStop;

class Gradient {
  constructor({
    type = GradientType.LINEAR,
    angleInDegree = 0.0,
    aspectRatio = 1.0,
    interpolationType = GradientInterpolationType.LINEAR,
    stops = [],
    opacityStops = []
  }) {
    this.type = GradientType.LINEAR;
    this.angleInDegree = 0.0;
    this.aspectRatio = 1.0;
    this.interpolationType = GradientInterpolationType.LINEAR;
    this.stops = [];
    this.opacityStops = [];
    this.type = type;
    this.angle = angleInDegree;
    this.aspectRatio = aspectRatio;
    this.interpolation = interpolationType;
    this.stops = stops;
    this.opacityStops = opacityStops;
  }

}

exports.Gradient = Gradient;